// dependencies
import React from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components

// actions
import { init } from "./actions";

// selectors

// css
import css from "./Page";

class Page extends React.PureComponent {
	static propTypes = {
		init: PropTypes.func.isRequired,
	};

	static defaultProps = {};

	componentDidMount = () => {
		this.props.init();
	};

	render = () => {
		return (
			<div className={css.Page}>
				<div className={css.addUserWrapper} />
			</div>
		);
	};
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
	init: () => dispatch(init()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);
